module.exports = __webpack_public_path__ + "img/dingding2023.fa11b8b3.jpg";